import { render } from "./AthenaLoginWidget.vue?vue&type=template&id=5cbf4e88"
import script from "./AthenaLoginWidget.vue?vue&type=script&lang=js"
export * from "./AthenaLoginWidget.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rswenson/code/arch/surfacing/src/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__